const campaignRouter = [
  {
    path: '/campaign/materials',
    name: 'campaign-materials',
    component: () =>
      import(/* webpackChunkName: "campaign" */ '../views/campaign/material'),
    meta: {
      isLogin: false,
    },
  },
  {
    path: '/campaign/materials/list',
    name: 'campaign-materials-list',
    component: () =>
      import(
        /* webpackChunkName: "campaign" */ '../views/campaign/material-list'
      ),
    meta: {
      isLogin: false,
    },
  },
  {
    path: '/campaign/materials/:id',
    name: 'campaign-materials-detail',
    component: () =>
      import(
        /* webpackChunkName: "campaign" */ '../views/campaign/material-detail'
      ),
    meta: {
      isLogin: false,
      diffShare: true
    },
  },
]

export default campaignRouter
